import { AudioOutlined, FormOutlined, VideoCameraOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import { MessageTypeEnum } from 'api/MessagesApi';
import AiAssistModalComponent from 'components/Message/SelectCreateMessageComponent/AiAssistModalComponent/AiAssistModalComponent';
import { useCompanyContext } from 'contexts/CompanyContext';
import { MessageAudioImage } from 'icons/MessageAudioImage';
import { MessageTextImage } from 'icons/MessageTextImage';
import { MessageVideoImage } from 'icons/MessageVideoImage';
import { useNavigate } from 'react-router-dom';
import './SelectCreateMessageComponent.css';

function SelectCreateMessageComponent() {
  const { companyConfig } = useCompanyContext();
  const navigate = useNavigate();

  const createMessage = (type: MessageTypeEnum) => {
    navigate('/message/new', { state: { messageType: type } });
  };


  const renderCard = ({ icon, title, image, onClick }) => {
    return (
      <Col xs={24} lg={8}>
        <div className="card box-shadow-animation" onClick={onClick}>
          <div className="image">{image}</div>
          <div className="title">
            <div>
              {icon} {title}
            </div>
          </div>
        </div>
      </Col>
    );
  };

  return (
    <div className="select-create-message-component" data-tour="create-message">
      <p className="title">Which message type would you like to leave?</p>
      <p className="subtitle text-center">Select from Written, Audio or Video message.</p>

      {/*<Flex justify="center">*/}
      {/*  <Button type="primary" size="large" onClick={openAiAssistModal} className="ai-assistant-button">*/}
      {/*    <BsStars /> Start an interview*/}
      {/*  </Button>*/}
      {/*</Flex>*/}

      <Row gutter={[20, 10]} className="cards">
        {renderCard({
          icon: <FormOutlined />,
          title: 'Written Message',
          image: <MessageTextImage color={companyConfig.colorPrimary} />,
          onClick: () => createMessage(MessageTypeEnum.Text)
        })}
        {renderCard({
          icon: <AudioOutlined />,
          title: 'Audio Message',
          image: <MessageAudioImage color={companyConfig.colorPrimary} />,
          onClick: () => createMessage(MessageTypeEnum.Audio)
        })}
        {renderCard({
          icon: <VideoCameraOutlined />,
          title: 'Video Message',
          image: <MessageVideoImage color={companyConfig.colorPrimary} />,
          onClick: () => createMessage(MessageTypeEnum.Video)
        })}
      </Row>

      <AiAssistModalComponent />
    </div>
  );
}

export default SelectCreateMessageComponent;
